export default __webpack_public_path__ + "static/media/icon-taks-note.a55e5e2d.svg";